import Modal from "components/Common/Modal";

const RateNotConfiguredModal = ({ show, onHide }) => (
  <Modal
    type="modal-sm"
    show={show}
    onHide={onHide}
    modalName="registration-rate-not-configured-modal"
    title="Investigation rate not set"
    body={
      <div>
        <p className="mb-2">
          This investigation can’t be added because its rate is missing or set
          to zero for the selected franchise.
        </p>
        <p className="mb-0">
          Please contact your administrator to set the rate, then select the
          investigation again.
        </p>
      </div>
    }
    footer={
      <button type="button" className="btn btn-primary" onClick={onHide}>
        Got it
      </button>
    }
  />
);

export default RateNotConfiguredModal;
